module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'marquees') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.config.direction),
      callback: function($$v) {
        _vm.$set(_vm.config, "direction", $$v)
      },
      expression: "config.direction"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "vertical"
    }
  }, [_vm._v("软文")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "horizontal"
    }
  }, [_vm._v("文本")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.bgcolor),
      callback: function($$v) {
        _vm.$set(_vm.config, "bgcolor", $$v)
      },
      expression: "config.bgcolor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字体颜色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.fontcolor),
      callback: function($$v) {
        _vm.$set(_vm.config, "fontcolor", $$v)
      },
      expression: "config.fontcolor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "vertical-align": "middle"
    },
    attrs: {
      "maxlength": "4",
      "placeholder": "标签文本"
    },
    model: {
      value: (_vm.config.label),
      callback: function($$v) {
        _vm.$set(_vm.config, "label", $$v)
      },
      expression: "config.label"
    }
  }), _vm._v(" "), _c('el-color-picker', {
    staticStyle: {
      "vertical-align": "middle"
    },
    model: {
      value: (_vm.config.labelcolor),
      callback: function($$v) {
        _vm.$set(_vm.config, "labelcolor", $$v)
      },
      expression: "config.labelcolor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n          标签文字最多4个字符\n        ")])]), _vm._v(" "), (_vm.config.direction === 'vertical') ? _c('el-form-item', {
    attrs: {
      "label": "软文"
    }
  }, [_c('draggable', {
    staticClass: "article",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "article-item"
    }, [_c('i', {
      staticClass: "iconfont icon-stream drag-handler"
    }), _vm._v(" "), _c('span', [_vm._v("\n              " + _vm._s(item.title) + "\n              "), _c('div', {
      staticClass: "iconfont icon-trash-alt btn-remove",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    })])])
  }), 0), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.showArticle
    }
  }, [_vm._v("选择软文")]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n          模板中的展示效果为模拟效果，实际展示效果以客户端为准。\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.config.direction === 'horizontal') ? _c('el-form-item', {
    attrs: {
      "label": "文本"
    }
  }, [_c('draggable', {
    staticClass: "article",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "article-item"
    }, [_c('i', {
      staticClass: "iconfont icon-stream drag-handler"
    }), _vm._v(" "), _c('span', [_c('el-input', {
      attrs: {
        "placeholder": "标题",
        "size": "small"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "自定义链接",
        "size": "small"
      },
      model: {
        value: (item.url),
        callback: function($$v) {
          _vm.$set(item, "url", $$v)
        },
        expression: "item.url"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash-alt btn-remove",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.handleTextAdd
    }
  }, [_vm._v("添加文本")]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n          模板中的展示效果为模拟效果，实际展示效果以客户端为准。\n        ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('articleSelector', {
    attrs: {
      "visible": _vm.articleVisible,
      "get-status": _vm.setArticleStatus,
      "rel-items-ids": _vm.relArticles
    },
    on: {
      "update:visible": function($event) {
        _vm.articleVisible = $event
      },
      "change": _vm.pickArticle
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37344b60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37344b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/marquees.vue
// module id = 2613
// module chunks = 0